































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app} from '@/shared/app.constants';

const namespace: string = "application";

@Component
export default class NegotiationLogComponent extends Vue {
  @Prop() appId: number;
  @Prop() title: string;
  @Prop() log: any;
  // log: Array<any> = new Array<any>();

  actions = _app.actions;
  subjects = _app.subjects;

  viewApplication(logId: number) {
    if (this.$route.name === "conceptNoteSummary") {
      let routeData = this.$router.resolve({
        name: "snapshotConceptNote",
        params: { conceptNoteId: this.appId.toString(), logId: logId.toString(), section: 'technicalApplication' },
      });

      window.open(routeData.href, "_blank");
    } else {
      let routeData = this.$router.resolve({
        name: "snapshot",
        params: { appId: this.appId.toString(), logId: logId.toString(), section: 'technicalApplication' },
      });

      window.open(routeData.href, "_blank");
    }
  }

  /** format the date time */
  formatDateTime(val) {
    return utils.dateFormat(val);
  }
}
